'use client';

import { Flex, Icon, Spacer, Text } from '@backyard-ui/core';

import useIsClient from '@/presenters/hooks/use-is-client';

import { WhatsAppIcon } from './WhatsAppIcon';

export default function OnDemand() {
  const isClient = useIsClient();

  const currentURL = isClient ? window.location.href : '';
  const text = `Ol%C3%A1,+gostaria+de+informações+sobre:+${currentURL}`;

  return (
    <Flex
      className="w-full border-t-4 border-neutral-700 pt-2"
      direction="column"
      data-testid="on-demand"
    >
      <Text size="3xl" color="neutral-700" asChild>
        <span>Item sob encomenda</span>
      </Text>
      <Spacer size="1" axis="vertical" />
      <Text
        size="md"
        weight="bold"
        color="primary-700"
        decoration="underline"
        asChild
      >
        <a
          href={`https://api.whatsapp.com/send?phone=551140071380&text=${text}`}
          rel="noopener noreferrer"
          target="_blank"
          aria-label="Clique aqui para falar com vendas à distância"
        >
          <Flex align="center">
            <Icon size="xs">
              <WhatsAppIcon />
            </Icon>
            <Spacer size="1" />
            <span>Clique aqui para falar com vendas à distância</span>
          </Flex>
        </a>
      </Text>
    </Flex>
  );
}
